export const SHOPFRONT_LANDING_PAGE_CONTACT_US =
  'shopfront-landing-page-contact-us';
export const ADVERTISER_ACTIVATION_COMPLETE_CONTACT_US =
  'advertiser-activation-complete-contact-us';
export const CREATE_ADVERTISER_COMPLETE_CONTACT_US =
  'create-advertiser-complete-contact-us';
export const USER_VERIFICATION_COMPLETE_CONTACT_US =
  'user-verification-complete-contact-us';
export const SHOPFRONT_LANDING_PAGE_HELP_CENTRE =
  'shopfront-landing-page-help-centre';
